import Apicall from '../rest/Apicall';



export const callAnyApi = async (url,object) => {    

    const data = await Apicall.callAnyApi(url,object);        
    return data;
};

export const getBaseURL = () => {    

    return Apicall.getBaseURL();     
    
};

export const uploadFile = (file, onUploadProgress,id,entityId,description,specialFile) => {

    return Apicall.uploadFile(file, onUploadProgress,id,entityId,description,specialFile);

}

export const getFile = (id) => {

    return Apicall.getFile(id);

}


export const downloadExceFile = async (url,object) => {    

    const data = await Apicall.downloadExceFile(url,object);     
      
    return data;
};